import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["title", "type", "Icon", "href", "routeKey", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { memo, useCallback, useMemo } from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { ArrowLeftOnRectangleIcon, ArrowUpRightIcon, Cog6ToothIcon, DocumentIcon, MapIcon, XMarkIcon, DocumentArrowUpIcon, SparklesIcon, UserGroupIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { UserCircleIcon } from '@heroicons/react/24/solid';
import Cookies from 'js-cookie';
import { useIntercom } from 'react-use-intercom';
import { config, HeadphoneAltIcon } from '@restworld/utils-common';
import { getAssetSrc, useNavigationContext } from '@restworld/utils-common';
import { Badge, IconButton, Link, Select, renderFlag, Button } from '@restworld/ui-ds-base';
import { useAuth } from '@restworld/feature-authentication';
import { Title, NavMenuItem, LinkBase } from '../../..';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

function NavMenuContent(_ref) {
  var onCloseMenu = _ref.onCloseMenu,
      avatarImageURL = _ref.avatarImageURL,
      workerInfo = _ref.workerInfo,
      onStartLogin = _ref.onStartLogin,
      onShowUploadCvModal = _ref.onShowUploadCvModal;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  var _useNavigationContext = useNavigationContext(),
      router = _useNavigationContext.router;

  var locale = useCurrentLocale();

  var _useAuth = useAuth(),
      user = _useAuth.user;

  var languageOptionsList = useLanguageOptionsList();

  var _useLocaleSwitch = useLocaleSwitch(),
      switchLocale = _useLocaleSwitch.switchLocale;

  var _useNavItemElements = useNavItemElements({
    avatarImageURL: avatarImageURL,
    workerInfo: workerInfo,
    onShowUploadCvModal: onShowUploadCvModal,
    onCloseMenu: onCloseMenu
  }),
      primaryNavItems = _useNavItemElements.primaryNavItems,
      primaryNavItemsTitle = _useNavItemElements.primaryNavItemsTitle,
      secondaryNavItems = _useNavItemElements.secondaryNavItems,
      secondaryNavItemsTitle = _useNavItemElements.secondaryNavItemsTitle,
      tertiaryNavItems = _useNavItemElements.tertiaryNavItems;

  var _useUserType = useUserType(),
      isEmployer = _useUserType.isEmployer,
      isAmbassador = _useUserType.isAmbassador;

  var localeSelectValue = useMemo(function () {
    var currentOption = languageOptionsList.find(function (v) {
      return v.key === locale;
    });
    if (currentOption) return _objectSpread(_objectSpread({}, currentOption), {}, {
      value: currentOption.key
    });
    return {
      label: '',
      value: ''
    };
  }, [languageOptionsList, locale]);
  var actionBtnText = useMemo(function () {
    return t(isEmployer ? 'return_to_personal_area' : isAmbassador ? 'return_to_dashboard' : 'log_in');
  }, [isAmbassador, isEmployer, t]);
  var onClickActionBtn = useCallback(function () {
    if (isEmployer) router.push('/v2/employer/homepage');else if (isAmbassador) router.push('/challenge-wom/dashboard');else if (onStartLogin) onStartLogin();
  }, [isAmbassador, isEmployer, onStartLogin, router]);
  return /*#__PURE__*/_jsxs(_StyledDiv, {
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs(_StyledDiv2, {
        children: [/*#__PURE__*/_jsx(LinkBase, {
          link: "/",
          newTab: false,
          children: /*#__PURE__*/_jsx(Image, {
            width: 34,
            height: 24,
            src: getAssetSrc('/utils-assets/small-restworld-logo.svg'),
            alt: "",
            priority: true
          })
        }), /*#__PURE__*/_jsx(IconButton, {
          ariaLabel: "close",
          Icon: XMarkIcon,
          onClick: onCloseMenu
        })]
      }), /*#__PURE__*/_jsxs(_StyledDiv3, {
        children: [!!primaryNavItemsTitle && /*#__PURE__*/_jsx(ItemGroupTitle, {
          content: primaryNavItemsTitle
        }), /*#__PURE__*/_jsx(ItemsWrapper, {
          children: primaryNavItems
        })]
      }), /*#__PURE__*/_jsxs(_StyledSectionWrapper, {
        hasTopBorder: !!(secondaryNavItems !== null && secondaryNavItems !== void 0 && secondaryNavItems.length),
        children: [!!secondaryNavItemsTitle && /*#__PURE__*/_jsx(ItemGroupTitle, {
          content: secondaryNavItemsTitle
        }), /*#__PURE__*/_jsx(ItemsWrapper, {
          children: secondaryNavItems
        })]
      })]
    }), /*#__PURE__*/_jsxs(SectionWrapper, {
      hasTopBorder: !!(tertiaryNavItems !== null && tertiaryNavItems !== void 0 && tertiaryNavItems.length),
      children: [/*#__PURE__*/_jsx(_StyledDiv4, {
        children: /*#__PURE__*/_jsx(ItemsWrapper, {
          children: tertiaryNavItems
        })
      }), /*#__PURE__*/_jsxs(_StyledDiv5, {
        children: [(!(user !== null && user !== void 0 && user.id) || isEmployer || isAmbassador) && /*#__PURE__*/_jsx(Button, {
          fullwidth: true,
          onClick: onClickActionBtn,
          StartIcon: isEmployer || isAmbassador ? ArrowUpRightIcon : undefined,
          children: actionBtnText
        }), /*#__PURE__*/_jsx(Select, {
          fullwidth: true,
          options: languageOptionsList.map(function (v) {
            return _objectSpread(_objectSpread({}, v), {}, {
              value: v.key
            });
          }),
          onChange: function onChange(v) {
            return switchLocale(v.value);
          },
          value: localeSelectValue,
          isContentCentered: true
        })]
      })]
    })]
  });
}

export default /*#__PURE__*/memo(NavMenuContent);
var RouteKey;

(function (RouteKey) {
  RouteKey["PROFILE"] = "profilo";
  RouteKey["JOB_EXPLORER"] = "cerco-lavoro";
  RouteKey["MY_APPLICATIONS"] = "candidature";
  RouteKey["FIND_ACCOMODATION"] = "find-accomodation";
  RouteKey["LEARN"] = "learn";
  RouteKey["GET_SUPPORT"] = "get-support";
  RouteKey["SETTINGS"] = "impostazioni";
  RouteKey["LOGOUT"] = "logout";
  RouteKey["UPLOAD_CV"] = "upload-cv";
  RouteKey["CREATE_CV"] = "candidati";
  RouteKey["HIRE_WITH_RW"] = "hire-with-rw";
  RouteKey["POST_VENUE"] = "post-venue";
})(RouteKey || (RouteKey = {}));

function useNavItems(_ref2) {
  var avatarImageURL = _ref2.avatarImageURL,
      workerInfo = _ref2.workerInfo,
      onShowUploadCvModal = _ref2.onShowUploadCvModal;

  var _useTranslation2 = useTranslation('common'),
      t = _useTranslation2.t;

  var _useIntercom = useIntercom(),
      showIntercom = _useIntercom.show;

  var _useAuth2 = useAuth(),
      logout = _useAuth2.logout;

  var isProfileComplete = workerInfo === null || workerInfo === void 0 ? void 0 : workerInfo.isProfileComplete;

  var _useUserType2 = useUserType(),
      isEmployer = _useUserType2.isEmployer,
      isAmbassador = _useUserType2.isAmbassador;

  var navItems = useMemo(function () {
    return [{
      title: /*#__PURE__*/_jsxs(_StyledSpan, {
        children: [/*#__PURE__*/_jsx(Title, {
          content: t('my_cv'),
          textColor: "neutral-700",
          fontSize: "base",
          fontWeight: "medium",
          twStyle: isProfileComplete ? undefined : {
            "marginBottom": "0.5rem"
          }
        }), !isProfileComplete && /*#__PURE__*/_jsx(Badge, {
          variant: "warning",
          children: /*#__PURE__*/_jsxs(_StyledSpan2, {
            children: [/*#__PURE__*/_jsx(ExclamationTriangleIcon, {
              className: "h-[16px] w-[16px"
            }), " ", /*#__PURE__*/_jsx("span", {
              children: t('complete_profile')
            })]
          })
        })]
      }),
      group: 'primary',
      type: 'default',
      Icon: avatarImageURL ? undefined : UserCircleIcon,
      imageUrl: avatarImageURL,
      href: '/profilo',
      routeKey: RouteKey.PROFILE
    }, {
      title: t(isEmployer || isAmbassador ? 'explore_map' : 'search_for_jobs'),
      group: 'primary',
      type: 'default',
      Icon: MapIcon,
      href: '/cerco-lavoro',
      routeKey: RouteKey.JOB_EXPLORER
    }, {
      title: t('my_applications'),
      group: 'primary',
      type: 'default',
      Icon: DocumentIcon,
      indicator: (workerInfo === null || workerInfo === void 0 ? void 0 : workerInfo.activeApplicationsCount) || undefined,
      href: '/candidature',
      routeKey: RouteKey.MY_APPLICATIONS
    }, {
      title: t('find_accommodation_with_partners'),
      group: 'secondary',
      type: 'externalLink',
      Icon: ArrowUpRightIcon,
      href: config.accomodationPartnerUrl,
      routeKey: RouteKey.FIND_ACCOMODATION
    }, {
      title: t('learn_with_partners'),
      group: 'secondary',
      type: 'externalLink',
      Icon: ArrowUpRightIcon,
      href: config.learningPartnerUrl,
      routeKey: RouteKey.LEARN
    }, {
      title: t('support'),
      group: 'tertiary',
      type: 'default',
      Icon: HeadphoneAltIcon,
      onClick: showIntercom,
      routeKey: RouteKey.GET_SUPPORT
    }, {
      title: t('settings'),
      group: 'tertiary',
      type: 'default',
      Icon: Cog6ToothIcon,
      href: '/impostazioni',
      routeKey: RouteKey.SETTINGS
    }, {
      title: t('log_out'),
      group: 'tertiary',
      type: 'default',
      Icon: ArrowLeftOnRectangleIcon,
      onClick: logout,
      routeKey: RouteKey.LOGOUT
    }, {
      title: t('upload_cv'),
      group: 'primary',
      type: 'default',
      Icon: DocumentArrowUpIcon,
      routeKey: RouteKey.UPLOAD_CV,
      onClick: onShowUploadCvModal
    }, {
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("span", {
          children: t('create_cv')
        }), " ", /*#__PURE__*/_jsx(RecommendedBadge, {})]
      }),
      group: 'primary',
      type: 'default',
      Icon: SparklesIcon,
      href: '/candidati',
      routeKey: RouteKey.CREATE_CV
    }, {
      title: t('hire_with_restworld'),
      group: 'secondary',
      type: 'default',
      Icon: UserGroupIcon,
      href: "".concat(config.hireWithRestworldTypeformUrl, "?utm_source=worker-app"),
      routeKey: RouteKey.HIRE_WITH_RW
    } // {
    //   title: t('post_your_venue_for_free'),
    //   group: 'secondary',
    //   type: 'default',
    //   Icon: BuildingOfficeIcon,
    //   href: '/getting-started?utm_source=worker-app',
    //   routeKey: RouteKey.POST_VENUE,
    // },
    ];
  }, [t, isProfileComplete, avatarImageURL, isEmployer, isAmbassador, workerInfo === null || workerInfo === void 0 ? void 0 : workerInfo.activeApplicationsCount, showIntercom, logout, onShowUploadCvModal]);
  return {
    navItems: navItems
  };
}

var workerRoutes = [RouteKey.PROFILE, RouteKey.JOB_EXPLORER, RouteKey.MY_APPLICATIONS, RouteKey.FIND_ACCOMODATION, RouteKey.LEARN, RouteKey.GET_SUPPORT, RouteKey.SETTINGS, RouteKey.LOGOUT];
var loggedOutUserRoutes = [RouteKey.JOB_EXPLORER, RouteKey.UPLOAD_CV, RouteKey.CREATE_CV, RouteKey.HIRE_WITH_RW, RouteKey.POST_VENUE];
var leadUserRoutes = [].concat(loggedOutUserRoutes, [RouteKey.LOGOUT]);
var employerOrAmbassadorRoutes = [RouteKey.JOB_EXPLORER, RouteKey.LOGOUT];

function useNavItemElements() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      avatarImageURL = _ref3.avatarImageURL,
      workerInfo = _ref3.workerInfo,
      onShowUploadCvModal = _ref3.onShowUploadCvModal,
      onCloseMenu = _ref3.onCloseMenu;

  var _useTranslation3 = useTranslation('common'),
      t = _useTranslation3.t;

  var _useNavItems = useNavItems({
    avatarImageURL: avatarImageURL,
    workerInfo: workerInfo,
    onShowUploadCvModal: onShowUploadCvModal
  }),
      navItems = _useNavItems.navItems;

  var _useUserType3 = useUserType(),
      isEmployer = _useUserType3.isEmployer,
      isLeadUser = _useUserType3.isLeadUser,
      isLoggedOut = _useUserType3.isLoggedOut,
      isWorker = _useUserType3.isWorker,
      isAmbassador = _useUserType3.isAmbassador;

  var _useRenderNavItems = useRenderNavItems(onCloseMenu),
      renderNavItems = _useRenderNavItems.renderNavItems;

  var primaryNavItems = useMemo(function () {
    var filteredItems = navItems.filter(function (item) {
      return item.group === 'primary';
    });
    if (isWorker) return renderNavItems(filteredItems.filter(function (item) {
      return workerRoutes.includes(item.routeKey);
    }));
    if (isEmployer || isAmbassador) return renderNavItems(filteredItems.filter(function (item) {
      return employerOrAmbassadorRoutes.includes(item.routeKey);
    }));
    return renderNavItems(filteredItems.filter(function (item) {
      return loggedOutUserRoutes.includes(item.routeKey);
    }));
  }, [isAmbassador, isEmployer, isWorker, navItems, renderNavItems]);
  var primaryNavItemsTitle = useMemo(function () {
    return isLoggedOut || isLeadUser ? t('looking_for_a_job') : '';
  }, [isLeadUser, isLoggedOut, t]);
  var secondaryNavItems = useMemo(function () {
    var filteredItems = navItems.filter(function (item) {
      return item.group === 'secondary';
    });
    if (isWorker) return renderNavItems(filteredItems.filter(function (item) {
      return workerRoutes.includes(item.routeKey);
    }));
    if (isEmployer || isAmbassador) return null;
    return renderNavItems(filteredItems.filter(function (item) {
      return loggedOutUserRoutes.includes(item.routeKey);
    }));
  }, [isAmbassador, isEmployer, isWorker, navItems, renderNavItems]);
  var secondaryNavItemsTitle = useMemo(function () {
    return isLoggedOut || isLeadUser ? t('looking_for_staff') : '';
  }, [isLeadUser, isLoggedOut, t]);
  var tertiaryNavItems = useMemo(function () {
    var filteredItems = navItems.filter(function (item) {
      return item.group === 'tertiary';
    });
    if (isWorker) return renderNavItems(filteredItems);
    if (isLeadUser) return renderNavItems(filteredItems.filter(function (item) {
      return leadUserRoutes.includes(item.routeKey);
    }));
    if (isEmployer || isAmbassador) return renderNavItems(filteredItems.filter(function (item) {
      return employerOrAmbassadorRoutes.includes(item.routeKey);
    }));
    return null;
  }, [isAmbassador, isEmployer, isLeadUser, isWorker, navItems, renderNavItems]);
  return {
    primaryNavItems: primaryNavItems,
    primaryNavItemsTitle: primaryNavItemsTitle,
    secondaryNavItems: secondaryNavItems,
    secondaryNavItemsTitle: secondaryNavItemsTitle,
    tertiaryNavItems: tertiaryNavItems
  };
}

function useRenderNavItems(onCloseMenu) {
  var _useNavigationContext2 = useNavigationContext(),
      router = _useNavigationContext2.router;

  var renderNavItems = useCallback(function (items) {
    return items.map(function (_ref4) {
      var title = _ref4.title,
          type = _ref4.type,
          Icon = _ref4.Icon,
          href = _ref4.href,
          routeKey = _ref4.routeKey,
          _onClick = _ref4.onClick,
          rest = _objectWithoutProperties(_ref4, _excluded);

      return type === 'externalLink' ? /*#__PURE__*/_jsx(Link, {
        variant: "restworld",
        StartIcon: Icon,
        href: href,
        onClick: onCloseMenu,
        children: title
      }, routeKey) : /*#__PURE__*/_jsx(NavMenuItem, _objectSpread(_objectSpread({
        isOpen: true,
        Icon: Icon,
        href: href,
        isSelected: router === null || router === void 0 ? void 0 : router.pathname.includes(routeKey),
        noV2Prefix: true,
        onClick: function onClick() {
          _onClick === null || _onClick === void 0 ? void 0 : _onClick();
          if (routeKey !== RouteKey.UPLOAD_CV) onCloseMenu === null || onCloseMenu === void 0 ? void 0 : onCloseMenu();
        }
      }, rest), {}, {
        children: title
      }), routeKey);
    });
  }, [onCloseMenu, router === null || router === void 0 ? void 0 : router.pathname]);
  return {
    renderNavItems: renderNavItems
  };
}

function useUserType() {
  var _useAuth3 = useAuth(),
      user = _useAuth3.user;

  var isLoggedOut = useMemo(function () {
    return !(user !== null && user !== void 0 && user.id);
  }, [user === null || user === void 0 ? void 0 : user.id]);
  var isWorker = useMemo(function () {
    return (user === null || user === void 0 ? void 0 : user.type) === 'worker';
  }, [user === null || user === void 0 ? void 0 : user.type]);
  var isLeadUser = useMemo(function () {
    return (user === null || user === void 0 ? void 0 : user.type) === 'lead';
  }, [user === null || user === void 0 ? void 0 : user.type]);
  var isEmployer = useMemo(function () {
    return (user === null || user === void 0 ? void 0 : user.type) === 'employer' || (user === null || user === void 0 ? void 0 : user.type) === 'employer_contact';
  }, [user === null || user === void 0 ? void 0 : user.type]);
  var isAmbassador = useMemo(function () {
    return (user === null || user === void 0 ? void 0 : user.type) === 'ambassador';
  }, [user === null || user === void 0 ? void 0 : user.type]);
  return {
    isWorker: isWorker,
    isLeadUser: isLeadUser,
    isEmployer: isEmployer,
    isAmbassador: isAmbassador,
    isLoggedOut: isLoggedOut
  };
}

var LANGUAGE_OPTIONS = {
  EN: 'en',
  IT: 'it'
};
var DEFAULT_LANGUAGE = LANGUAGE_OPTIONS.IT;
export function useLanguageOptionsList() {
  var _useTranslation4 = useTranslation('common'),
      t = _useTranslation4.t;

  var languageOptions = useMemo(function () {
    return [{
      id: LANGUAGE_OPTIONS.IT,
      key: LANGUAGE_OPTIONS.IT,
      label: t('italian_lang_key'),
      icon: renderFlag('IT')
    }, {
      id: LANGUAGE_OPTIONS.EN,
      key: LANGUAGE_OPTIONS.EN,
      label: t('english_lang_key'),
      icon: renderFlag('GB')
    }];
  }, [t]);
  return languageOptions;
}
export function useCurrentLocale() {
  var _useNavigationContext3 = useNavigationContext(),
      router = _useNavigationContext3.router;

  var locale = router.locale || DEFAULT_LANGUAGE;
  return locale;
}
export function useLocaleSwitch() {
  var _useNavigationContext4 = useNavigationContext(),
      router = _useNavigationContext4.router;

  var basePath = router.asPath;
  var switchLocale = useCallback(function (language) {
    Cookies.set('NEXT_LOCALE', language, {
      expires: 365 * 24 * 60 * 60
    });
    router.push(basePath, basePath, {
      locale: language
    });
  }, [basePath, router]);
  return {
    switchLocale: switchLocale
  };
}

function ItemGroupTitle(_ref5) {
  var content = _ref5.content;
  return /*#__PURE__*/_jsx(Title, {
    content: content,
    fontSize: "base",
    fontWeight: "semibold",
    textColor: "neutral-700",
    twStyle: {
      "marginBottom": "1.25rem"
    }
  });
}

function RecommendedBadge() {
  var _useTranslation5 = useTranslation('common'),
      t = _useTranslation5.t;

  return /*#__PURE__*/_jsx(Badge, {
    variant: "fresh",
    children: t('recommended')
  });
}

var ItemsWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "nav-menu-content__ItemsWrapper",
  componentId: "sc-wh1w7p-0"
})(["", ""], {
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.75rem"
});

var SectionWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "nav-menu-content__SectionWrapper",
  componentId: "sc-wh1w7p-1"
})(["", ""], function (_ref6) {
  var hasTopBorder = _ref6.hasTopBorder;
  return hasTopBorder ? {
    "borderTopWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))"
  } : {};
});

var _StyledSectionWrapper = /*#__PURE__*/_styled(SectionWrapper).withConfig({
  displayName: "nav-menu-content___StyledSectionWrapper",
  componentId: "sc-wh1w7p-2"
})({
  "paddingTop": "1.25rem"
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "nav-menu-content___StyledDiv",
  componentId: "sc-wh1w7p-3"
})({
  "display": "flex",
  "height": "100%",
  "maxHeight": "100svh",
  "width": "100%",
  "flexDirection": "column",
  "justifyContent": "space-between",
  "overflow": "auto",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingBottom": "1.5rem",
  "paddingTop": "0.75rem"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "nav-menu-content___StyledDiv2",
  componentId: "sc-wh1w7p-4"
})({
  "marginBottom": "2.5rem",
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "nav-menu-content___StyledDiv3",
  componentId: "sc-wh1w7p-5"
})({
  "paddingBottom": "1.25rem"
});

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "nav-menu-content___StyledDiv4",
  componentId: "sc-wh1w7p-6"
})({
  "paddingTop": "1.5rem",
  "paddingBottom": "1.5rem"
});

var _StyledDiv5 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "nav-menu-content___StyledDiv5",
  componentId: "sc-wh1w7p-7"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.75rem"
});

var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  displayName: "nav-menu-content___StyledSpan",
  componentId: "sc-wh1w7p-8"
})({
  "display": "block"
});

var _StyledSpan2 = /*#__PURE__*/_styled("span").withConfig({
  displayName: "nav-menu-content___StyledSpan2",
  componentId: "sc-wh1w7p-9"
})({
  "display": "flex",
  "alignItems": "center",
  "gap": "0.25rem"
});